import React, { useState, useEffect } from "react";

import { Section } from "shared/layout";
import TabActionBar from "shared/TabActionBar";
import Button from "shared/Button";
import Table from "shared/Table";

import styles from "./index.module.css";

export default function TopicUsers({ isGroup, header, onClose, userData }) {
  const [users, setUsers] = useState([]); // Initialize as an empty array

  useEffect(() => {
    if (Array.isArray(userData) && userData.length > 0) {
      setUsers(userData); // Set users if valid data is received
    } else {
      setUsers([]); // Set to an empty array if no data or invalid data
    }
  }, [userData]);

  // Helper function to determine status with date and time
  const getStatus = (user) => {
    if (user.serverDeletedAt) {
      return `Deleted on ${new Date(user.serverDeletedAt).toLocaleString()}`;
    }
    if (user.serverCreatedAt) {
      return `Added on ${new Date(user.serverCreatedAt).toLocaleString()}`;
    }
    return "Unknown";
  };

  return (
    <div>
      <Section className={styles.section}>
        <TabActionBar>
          <header className={styles.tabActionBarHeader}>
            <h3 className={styles.title}>
              {header} {isGroup ? "Group" : "Thread"} Users
            </h3>
            <div>
              <Button
                size="small"
                onClick={() => {
                  onClose();
                }}
              >
                Close
              </Button>
            </div>
          </header>
        </TabActionBar>
      </Section>
      <Section>
        {users.length > 0 ? (
          <Table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Topic ID</th>
                <th>Status</th> {/* Add Status column */}
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>
                    {user.firstName} {user.lastName}
                    <div>
                      {user.avatarFilePath ? (
                        <img
                          alt="Topics User"
                          className={styles.profilePhoto}
                          src={user.avatarFilePath}
                        />
                      ) : null}
                    </div>
                  </td>
                  <td>{user.email}</td>
                  <td>{user.topicsId}</td>
                  <td>{getStatus(user)}</td> {/* Display status */}
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <h4>No users found.</h4>
        )}
      </Section>
    </div>
  );
}
